import parseISO from 'date-fns/parseISO'
import add from 'date-fns/add'
import isWithinInterval from 'date-fns/isWithinInterval'
import {useCustomerStore, useGlobalStore} from '../store/hooks/useStore'
import {DeliverySlot, TimeSlot} from '../types/store/basket'

export type VipRestrictions = {
  schedule: [
    {
      dateTime: {
        endTime: string
        startTime: string
      }
    },
  ]
  groups: string[]
  restrictions: [
    {
      daysFromToday?: number
      enabled?: boolean
      lastForDays?: number
    },
  ]
}[]

export const useVipRestrictions = () => {
  const {customSitePreferences} = useGlobalStore()
  const {currentCustomerGroups} = useCustomerStore()

  const isVipDeliverySlot = (day: DeliverySlot) => {
    if (day.hasVipSlots) {
      return true
    }

    if (day.hasVipSlots === false) {
      return false
    }

    return false
  }

  const isVipTimeSlot = (slot: TimeSlot) => {
    let isVipTimeSlotFlag = false

    const now = Date.now()

    const vipRestrictions = customSitePreferences['vipRestrictionsConfig'] as VipRestrictions

    if (!vipRestrictions?.length) {
      return false
    }

    const {vipSlot, windowStartTime} = slot

    const start = parseISO(windowStartTime)

    if (vipSlot) {
      return true
    }

    if (vipSlot === false) {
      return false
    }

    for (const vipRestrictionRule of vipRestrictions) {
      const allowedGroups = vipRestrictionRule.groups

      if (!allowedGroups?.length) {
        continue
      }

      const customerHasAllowedGroup = allowedGroups.some((allowed) =>
        currentCustomerGroups.includes(allowed),
      )

      if (!customerHasAllowedGroup) {
        continue
      }

      for (const schedule of vipRestrictionRule.schedule) {
        for (const restriction of vipRestrictionRule.restrictions) {
          if (typeof restriction.daysFromToday === 'number') {
            const shiftedStart = add(now, {
              days: restriction.daysFromToday,
            })
            const shiftedEnd = add(shiftedStart, {
              days: restriction.lastForDays,
            })
            const withinShiftedInterval = isWithinInterval(start, {
              start: shiftedStart,
              end: shiftedEnd,
            })

            if (withinShiftedInterval) {
              isVipTimeSlotFlag = true
              break
            }
          }
        }

        const withinInterval = isWithinInterval(start, {
          start: parseISO(schedule.dateTime.startTime),
          end: parseISO(schedule.dateTime.endTime),
        })

        if (withinInterval) {
          isVipTimeSlotFlag = true
          break
        }
      }
    }

    return isVipTimeSlotFlag
  }

  return {
    isVipTimeSlot,
    isVipDeliverySlot,
  }
}
